import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'single-comment',
  standalone: false,
  templateUrl: 'single-comment.component.html',
  styles: [`
    .close { 
      float: right; 
      border-radius: 100px; 
      position: absolute; 
      right: 24px; 
      top: 12px; 
    }

    mat-form-field {
      width: 300px;
    }

  `]
})

export class SingleCommentComponent implements OnInit {

  comentario: string;

  constructor(public dialogRef: MatDialogRef<SingleCommentComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.comentario = data.comentario;
  }

  ngOnInit() {
  }
}
